<template>
  <div v-if="isVisible" class="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div class="bg-white rounded-lg shadow-lg w-[90%] max-w-lg p-6">
      <h2 class="text-lg font-bold mb-2">Документы для печати</h2>
      <p class="text-sm text-gray-600 mb-4">
        Перед запуском заказа распечатайте следующие документы из спецификации:
      </p>
      <ul class="space-y-2 mb-6 max-h-60 overflow-y-auto">
        <li
          v-for="(file, index) in files"
          :key="file.id"
          class="flex items-center justify-between p-3 bg-gray-50 rounded-lg"
        >
          <span class="text-sm font-medium text-gray-800 truncate flex-1 mr-2">
            {{ index + 1 }}. {{ file.original_name || file.name || 'Документ' }}
          </span>
          <button
            type="button"
            class="px-3 py-1 text-sm font-medium text-blue-600 hover:text-blue-800 hover:bg-blue-50 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
            @click="printFile(file)"
          >
            Печать
          </button>
        </li>
      </ul>
      <div class="flex justify-end space-x-2">
        <button
          type="button"
          class="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-200 rounded-md hover:bg-gray-300 focus:outline-none focus:ring-2 focus:ring-gray-500"
          @click="$emit('cancel')"
        >
          Отмена
        </button>
        <button
          type="button"
          class="px-4 py-2 text-sm font-medium text-white bg-green-600 rounded-md hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-green-500"
          @click="$emit('confirm')"
        >
          Запустить заказ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrintFilesModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    files: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    printFile(file) {
      if (!file?.id) return;
      const printWindow = window.open(`/api/files/${file.id}/preview`, '_blank');
      if (printWindow) {
        printWindow.onload = () => {
          setTimeout(() => {
            printWindow.print();
            printWindow.onafterprint = () => printWindow.close();
          }, 500);
        };
      }
    },
  },
};
</script>
